import { render, staticRenderFns } from "./GisogdSectionDocs.vue?vue&type=template&id=a3001ae2&scoped=true&"
import script from "./GisogdSectionDocs.vue?vue&type=script&lang=js&"
export * from "./GisogdSectionDocs.vue?vue&type=script&lang=js&"
import style0 from "./GisogdSectionDocs.vue?vue&type=style&index=0&id=a3001ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3001ae2",
  null
  
)

export default component.exports